import SectionMain from './SectionMain';

export default SectionMain;
